import axios from 'axios';

export const loginAPI = (payload) => axios.post('{server}/admin/login', payload).then(res => res.data.success);